// extracted by mini-css-extract-plugin
export var closeButton = "_6i-0";